module.exports = __webpack_public_path__ + "static/img/AISON爱畅K歌音箱.420f181e.png";